module.exports = __webpack_public_path__ + "img/ZW.f7a6b0e1.svg";